module.exports = __webpack_public_path__ + "img/logo_azul.b307338d.png";